// Central content source. `logo` points to the real product app icon.
// `screenshot` stays null until real UI screenshots are provided.

export const LINKEDIN_URL = "https://www.linkedin.com/in/hendrikurniawan/";

export const products = [
  {
    id: "playvia",
    name: "Playvia",
    category: "Family",
    url: "https://playvia.lovable.app/landing",
    differentiator: "Parent-first screen-free play",
    explanation:
      "A screen-free activity companion for parents who need quick, meaningful ideas for play.",
    dna: ["Open", "Choose", "Play", "Notice", "Connect"],
    accent: "#8B7DD8",
    logo: "/logos/playvia.png",
    screenshot: null,
  },
  {
    id: "mindbrief",
    name: "MindBrief",
    category: "Knowledge",
    url: "https://mindbriefapp.lovable.app/landing",
    differentiator: "Connected knowledge, not isolated summaries",
    explanation:
      "A personal knowledge companion that turns reading into ideas you can connect and use.",
    dna: ["Read", "Discover", "Connect", "Apply"],
    accent: "#4F52C0",
    logo: "/logos/mindbrief.png",
    screenshot: null,
  },
  {
    id: "readywork",
    name: "ReadyWork",
    category: "Career",
    url: "https://readywork.lovable.app/readywork",
    differentiator: "A clearer path through the job search",
    explanation:
      "A guided job-search companion for building stronger applications, preparing better, and moving forward with more clarity.",
    dna: ["Direction", "CV", "Fit", "Prepare", "Communicate", "Apply"],
    accent: "#2E7BC4",
    logo: "/logos/readywork.png",
    screenshot: null,
  },
  {
    id: "skripsinext",
    name: "SkripsiNext",
    category: "Academic",
    url: "https://skripsinext.lovable.app/skripsinext",
    differentiator: "A calmer final-year workflow",
    explanation:
      "A final-project companion for organizing revisions, supervisor feedback, guidance sessions, and the next step.",
    dna: ["Focus", "Revise", "Prepare", "Progress"],
    accent: "#4E8069",
    logo: "/logos/skripsinext.png",
    screenshot: null,
  },
  {
    id: "profitpop",
    name: "ProfitPop",
    category: "Business",
    url: "https://profitpop.lovable.app/landing",
    differentiator: "Simple clarity for everyday business decisions",
    explanation:
      "A practical business companion for understanding numbers, evaluating changes, and deciding what to do next.",
    dna: ["Track", "Understand", "Act", "Improve"],
    accent: "#2E9E77",
    logo: "/logos/profitpop.png",
    screenshot: null,
  },
  {
    id: "uptoday",
    name: "UpToday",
    category: "Focus",
    url: "https://uptoday.lovable.app/landing",
    differentiator: "Calm productivity, not task overload",
    explanation:
      "A daily reset companion for choosing what matters, moving through the day, and closing it with clarity.",
    dna: ["Reset", "Choose 3", "Move", "Close", "Learn"],
    accent: "#6E8FD1",
    logo: "/logos/uptoday.png",
    screenshot: null,
  },
  {
    id: "sebelumsah",
    name: "SebelumSah",
    category: "Wedding",
    url: "https://sebelumsah.com/",
    differentiator: "Clarity before the next payment",
    explanation:
      "A pre-payment decision companion that helps couples see what is clear, what still needs checking, and what needs attention before paying wedding vendors.",
    dna: ["Plan", "Check", "Pay", "Ready"],
    accent: "#C2557A",
    logo: "/logos/sebelumsah.png",
    screenshot: null,
    showcase: true,
  },
];

export const getProduct = (id) => products.find((p) => p.id === id);

export const heroProducts = ["playvia", "mindbrief", "sebelumsah"].map(getProduct);

export const featuredProducts = ["playvia", "mindbrief"].map(getProduct);

export const secondaryProducts = [
  "readywork",
  "skripsinext",
  "profitpop",
  "uptoday",
  "sebelumsah",
].map(getProduct);

export const buildSteps = [
  {
    n: "01",
    title: "Understand the Tension",
    body: "Start with a real everyday problem worth solving.",
  },
  {
    n: "02",
    title: "Simplify",
    body: "Reduce the problem into the smallest useful product experience.",
  },
  {
    n: "03",
    title: "Build",
    body: "Use product strategy, design, AI-assisted workflows, and modern no-code tools to ship quickly.",
  },
  {
    n: "04",
    title: "Test & Learn",
    body: "Package the product, bring it to market, learn from real usage, and improve what matters.",
  },
];

export const upcomingProducts = [
  {
    id: "sideready",
    name: "SideReady",
    category: "Opportunity",
    mark: "SR",
    logo: "/logos/sideready.png",
    description:
      "A guided path from practical skills to a realistic starting opportunity.",
    accent: "#3E7C8C",
  },
  {
    id: "scopelock",
    name: "ScopeLock",
    category: "Execution",
    mark: "SL",
    logo: "/logos/scopelock.png",
    description:
      "Focused clarity for keeping scope, priorities, and execution aligned.",
    accent: "#3B4A66",
  },
];

export const capabilities = [
  "Product Strategy",
  "Consumer Insight",
  "AI-Enabled Research",
  "Product Design",
  "Commercial Thinking",
  "Digital Product Development",
];
